import { GetConfigByCityIdOutput } from '../../domain/auth/dtos/get-config-by-city-id.output';
import { ACCOUNT_CREATION_INTENT, buildEncodedState } from './state-handler';

const COMPANIES_SCOPE = 'govbr_empresa';

export interface OidcContinuation {
  redirectTo?: string;
  returnTo?: string;
}

/**
 * Traduz a continuação para o formato do `postAuth`: o `redirectTo` é o destino, e o
 * `returnTo` viaja em `additionalParams`, como no fluxo por senha.
 */
export function postAuthContinuation({ redirectTo, returnTo }: OidcContinuation) {
  if (!redirectTo) return {};
  return {
    redirectTo,
    ...(returnTo ? { additionalParams: { returnTo } } : {}),
  };
}

export function govBrAuthorizeBaseUrl(
  config: GetConfigByCityIdOutput
): string | undefined {
  return config.methods?.find((method) => method.strategy === 'GOV_BR')
    ?.config?.['url'];
}

export function govBrLoginUrl(
  baseUrl: string,
  customUrlRedirect: string,
  continuation: OidcContinuation = {}
): string {
  return withState(new URL(baseUrl), customUrlRedirect, { ...continuation });
}

/** Authorize que também pede as empresas vinculadas ao CPF. */
export function govBrAccountCreationUrl(
  baseUrl: string,
  customUrlRedirect: string,
  continuation: OidcContinuation = {}
): string {
  const url = new URL(baseUrl);
  const scopes = (url.searchParams.get('scope') ?? '').split(' ').filter(Boolean);
  url.searchParams.set(
    'scope',
    [...new Set([...scopes, COMPANIES_SCOPE])].join(' ')
  );
  return withState(url, customUrlRedirect, {
    ...continuation,
    intent: ACCOUNT_CREATION_INTENT,
  });
}

function withState(
  url: URL,
  customUrlRedirect: string,
  extra: Record<string, string | undefined>
): string {
  url.searchParams.set(
    'state',
    buildEncodedState(customUrlRedirect, url.searchParams.get('state') || '', extra)
  );
  return decodeURIComponent(url.toString());
}
